import './careers.css';
import React from 'react';

const AboutAutzuText = () => {
  return (
    <p className="text">
      Autzu is a drivesharing platform which aims to decrease global carbon
      emissions by switching all rideshare vehicles to electric. This is
      being accomplished by building smart and sustainable infrastructure
      for vehicle control, charging and connectivity.
    </p>
  );
};

export default AboutAutzuText;



// WEBPACK FOOTER //
// ./src/components/Careers/AboutAutzuText.js